export class NumberFormatValueConverter {
	toView(value) {
        if(value == null) return '';

        return Number(value).toLocaleString();
	}
}
